import '../../../../modules/back-button';
import '../../../../modules/close-app-button';
import {pages} from '../../../../modules/constants-enumerate';
import '../../../../modules/link-to-element';
import '../../../../modules/picture';

export default (ctx, html) => html`
  <main id="download-header">
    ${ctx.displayBackButton ? html`
      <div class="back-button-container">
        <back-button></back-button>
      </div>
    ` : ''}

    ${ctx.displayCloseAppButton ? html`
      <div class="side-container">
        <close-app-button class="link button yellow">Exit Game</close-app-button>
      </div>
    ` : ''}

    ${!ctx.displayCloseAppButton && !ctx.displayBackButton ? html`
      <div class="side-container">
        <slot name="left"></slot>
      </div>
    ` : ''}

    <div id="skip-navigation">
      <slot name="skip-navigation"></slot>
    </div>

    <div id="header">
      ${ctx.preventRedirect ? html`
        <aofl-picture id="header-logo">
          <aofl-source media="(max-width: 768px)" srcset="/assets/routes/download/adventure-academy-no-badge-logo-mb-v1.png" alt="Adventure Academy Logo"></aofl-source>
          <aofl-img src="/assets/routes/download/logo-ribbon-dt-v1-4x.png" width="594" height="180" alt="Adventure Academy Logo"></aofl-img>
        </aofl-picture>
      ` : html`
        <link-to dom-scope="prxAAHVS" id="logo" href="${pages.HOME}">
          <aofl-picture id="aofl-logo">
            <aofl-source media="(max-width: 768px)" srcset="/assets/routes/download/adventure-academy-no-badge-logo-mb-v1.png" alt="Adventure Academy Logo"></aofl-source>
            <aofl-img src="/assets/routes/download/logo-ribbon-dt-v1-4x.png" width="594" height="180" alt="Adventure Academy Logo"></aofl-img>
          </aofl-picture>
        </link-to>
      `}
    </div>

    <div id="right" class="side-container">
      <slot name="right"></slot>
    </div>
  </main>
`;
